import type { ClearingInstitutionsPageProps, PageProps } from "@/types";
import React, { FC } from "react";
import {
  ClearingInstitutionsDerisk,
  ClearingInstitutionsHero,
  ClearingInstitutionsHighRiskClassification,
  ClearingInstitutionsKeepingYouOut,
  ClearingInstitutionsRegulators,
  ClearingInstitutionsUniqueCapabilities,
} from "../clearing-institutions";
import { Cta } from "../cta";
import { NextPage } from "../next-page";

export const ClearingInstitutions: FC<PageProps<
  ClearingInstitutionsPageProps
>> = (props) => {
  return (
    <div>
      <ClearingInstitutionsHero
        label="Clearing Institutions"
        title={props.data.title}
        description={props.data.description}
        gallery={props.data.gallery}
      />
      <ClearingInstitutionsDerisk
        content={props.data.deriskContent}
        gallery={props.data.deriskGallery}
      />
      <ClearingInstitutionsUniqueCapabilities
        content={props.data.uniqueCapabilitiesContent}
        gallery={props.data.uniqueCapabilitiesGallery}
      />
      {/* TODO: Temporary hidden */}
      {/* <div className="wrapper wrapper_lg">
        <Cta
          cta={props.data.clearingInstitutionCta}
          className="clearingInstitutionsCta"
        />
      </div> */}
      <ClearingInstitutionsHighRiskClassification
        content={props.data.highRiskClassification}
      />
      <ClearingInstitutionsRegulators
        content={props.data.regulatorsContent}
        cover={props.data.regulatorsCover}
      />
      <ClearingInstitutionsKeepingYouOut
        title={props.data.keepingYouOutTitle}
        cards={props.data.keepingYouOutCards}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
